


import { Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Col, Form, Dropdown, Row, Container } from "react-bootstrap";
import { TableBody, TablePagination } from '@mui/material';
import Paper from "@mui/material/Paper";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import jsPDF from 'jspdf';
import { Box, Menu, MenuItem } from "@mui/material";
import { FiSearch } from 'react-icons/fi';

import 'jspdf-autotable';



const LeadReport = () => {
  const [ttowerno, setTowardsTowerNumber] = useState("");
  const [responset, setResponset] = useState([]);
  const [prname, setPrName] = useState("");
  const [vPrname,setVPrname]=useState('');
  const [projectName, setProjectName] = useState([]);
  const [fetchLeadData, setLeadFetchedData] = useState([]);
  const [projectNameVilla, setProjectNameVilla] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [viewMode, setViewMode] = useState('Full View');
  const [selectedColumns, setSelectedColumns] = useState([
    { id: 'name', label: 'Name', width: 200, isVisible: true },
    { id: 'email', label: 'Email', width: 200, isVisible: true },
    { id: 'mobile', label: 'Mobile', width: 150, isVisible: true },
    { id: 'ProjectName', label: 'Project Name', width: 200, isVisible: true },
    { id: 'occupation', label: 'Occupation', width: 150, isVisible: true },
    { id: 'remarks', label: 'Remarks', width: 200, isVisible: true },
    { id: 'address', label: 'Address', width: 200, isVisible: true },
    { id: 'age', label: 'Age', width: 100, isVisible: true },
    { id: 'aptsize', label: 'Apartment Size', width: 150, isVisible: true },
    { id: 'area', label: 'Area', width: 150, isVisible: true },
    { id: 'budget', label: 'Budget', width: 150, isVisible: true },
    { id: 'callBackTab', label: 'Callback Tab', width: 150, isVisible: true },
    { id: 'cbComment', label: 'Callback Comment', width: 200, isVisible: true },
    { id: 'cbDate', label: 'Callback Date', width: 150, isVisible: true },
    { id: 'channelPartner', label: 'Channel Partner', width: 200, isVisible: true },
    { id: 'commentBox', label: 'Comment Box', width: 200, isVisible: true },
    { id: 'commentSiteVisit', label: 'Comment Site Visit', width: 200, isVisible: true },
    { id: 'cornor', label: 'Corner', width: 100, isVisible: true },
    { id: 'cpId', label: 'Channel Partner ID', width: 150, isVisible: true },
    { id: 'cpName', label: 'Channel Partner Name', width: 200, isVisible: true },
    { id: 'dob', label: 'Date of Birth', width: 150, isVisible: true },
    { id: 'empType', label: 'Employment Type', width: 150, isVisible: true },
    { id: 'executive', label: 'Executive', width: 200, isVisible: true },
    { id: 'facing', label: 'Facing', width: 100, isVisible: true },
    { id: 'financeType', label: 'Finance Type', width: 150, isVisible: true },
    { id: 'flag', label: 'Flag', width: 100, isVisible: true },
    { id: 'flatdtls', label: 'Flat Details', width: 200, isVisible: true },
    { id: 'gender', label: 'Gender', width: 100, isVisible: true },
    { id: 'interestfloor', label: 'Interest Floor', width: 150, isVisible: true },
    { id: 'intrestComment', label: 'Interest Comment', width: 200, isVisible: true },
    { id: 'intrestDate', label: 'Interest Date', width: 150, isVisible: true },
    { id: 'intrestTab', label: 'Interest Tab', width: 100, isVisible: true },
    { id: 'isBooked', label: 'Is Booked', width: 100, isVisible: true },
    { id: 'leadDate', label: 'Lead Date', width: 150, isVisible: true },
    { id: 'location', label: 'Location', width: 200, isVisible: true },
    { id: 'mobile', label: 'Mobile', width: 150, isVisible: true },
    { id: 'notIntrstTab', label: 'Not Interested Tab', width: 150, isVisible: true },
    { id: 'notintrstComment', label: 'Not Interested Comment', width: 200, isVisible: true },
    { id: 'notintrstReason', label: 'Not Interested Reason', width: 200, isVisible: true },
    { id: 'pinCode', label: 'Pin Code', width: 100, isVisible: true },
    { id: 'pretime', label: 'Preferred Time', width: 150, isVisible: true },
    { id: 'productIntrest', label: 'Product Interest', width: 200, isVisible: true },
    { id: 'refMobile', label: 'Reference Mobile', width: 150, isVisible: true },
    { id: 'refName', label: 'Reference Name', width: 200, isVisible: true },
    { id: 'refucin', label: 'Reference Ucin', width: 200, isVisible: true },
    { id: 'rmdate', label: 'RM Date', width: 150, isVisible: true },
    { id: 'salesExecutive', label: 'Sales Executive', width: 200, isVisible: true },
    { id: 'salesExecutiveEmail', label: 'Sales Executive Email', width: 200, isVisible: true },
    { id: 'sitevistTab', label: 'Site Visit Tab', width: 100, isVisible: true },
    { id: 'sourceType', label: 'Source Type', width: 150, isVisible: true },
    { id: 'state', label: 'State', width: 150, isVisible: true },
    { id: 'street', label: 'Street', width: 200, isVisible: true },
    { id: 'ucon', label: 'UCON', width: 100, isVisible: true },
    { id: 'updatedate', label: 'Update Date', width: 150, isVisible: true },
    { id: 'updatetype', label: 'Update Type', width: 150, isVisible: true },
    { id: 'visidate', label: 'Visit Date', width: 150, isVisible: true },
    { id: 'wamobile', label: 'WA Mobile', width: 100, isVisible: true },
  ]);
  const [selectedColumnIds, setSelectedColumnIds] = useState(selectedColumns.filter(col => col.isVisible).map(col => col.id));

  useEffect(() => {
    const updatedColumns = selectedColumns.map(col => ({
      ...col,
      isVisible: viewMode === 'Full View' ? true : selectedColumnIds.includes(col.id)
    }));
    setSelectedColumns(updatedColumns);
  }, [viewMode, selectedColumnIds]);

  // const getFloor = () => {
  //   axios
  //     .post("https://buildfastapi.kollagroup.in/project/api/v1/towers-getall")
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setResponset(res.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching floor data:", error);
  //     });
  // };

  // const getProjectNames = () => {
  //   axios
  //     .get("https://buildfastapi.kollagroup.in/project/api/v1/get-basic")
  //     .then((res) => {
  //       setProjectName(res.data.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // useEffect(() => {
  //   getFloor();
  //   getProjectNames();
  // }, []);

  // const fetchLeadReportData = async () => {
  //   try {
  //     const response = await axios.get(`https://buildfastapi.kollagroup.in/api/v1/get-lead-report?projectname=${prname}`);
  //     if (response.status >= 200 && response.status < 300) {
  //       setLeadFetchedData(response.data);
  //     } else {
  //       throw new Error('Error fetching lead report data');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // useEffect(() => {
  //   if (prname) {
  //     fetchLeadReportData();
  //   }
  // }, [prname]);

  useEffect(()=>{
    getVillaProjectNames()
  },[])


  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
    });

    const columns = selectedColumns
      .filter(col => col.isVisible)
      .map(col => ({
        header: col.label,
        dataKey: col.id,
      }));

    const rows = leads.map(row => {
      const filteredRow = {};
      selectedColumns.forEach(col => {
        if (col.isVisible) {
          filteredRow[col.id] = row[col.id] || '';
        }
      });
      return filteredRow;
    });

    doc.autoTable({
      columns,
      body: rows,
      margin: { top: 10, left: 10 },
      columnStyles: {
        0: { cellWidth: '80' },
      },
      theme: 'striped',
      didDrawPage: (data) => {
        doc.text('Lead Report', 14, 22);
        doc.text(`Page ${data.pageNumber} of ${data.pageCount}`, doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 10);
      },
    });

    doc.save('lead_report.pdf');
  };

  const handleColumnSelection = (colId) => {
    setSelectedColumnIds(prev =>
      prev.includes(colId) ? prev.filter(id => id !== colId) : [...prev, colId]
    );
  };

  const [filterInput, setFilterInput] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  const [filteredProjects, setFilteredProjects] = useState([]);

  useEffect(() => {
    const userType = sessionStorage.getItem("userType");
    const projectNames = sessionStorage.getItem("ProjectName");

    // Filter projectNamesss based on userType and ProjectName
    const filtered = projectNameVilla.filter(project => {
      if (userType === "Admin") {
        return project.ProjectName === projectNames;
      }
      return true; // Show all projects for non-admins
    });

    setFilteredProjects(filtered);
  }, [projectNameVilla]);


  const getVillaProjectNames = () => {
    axios
      .get('https://buildfastvapi.emedha.in/project/api/v1/get-basic')
      .then((res) => {
        setProjectNameVilla(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [leads, setLeads] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Function to fetch data from the backend based on projectName
  const fetchLeads = async () => {
    setLoading(true);  // Set loading to true when the request is made
    setError(null);    // Reset error before making the request
  
 // Show alert when fetching starts
  
    try {
      const response = await axios.get(`https://buildfastvapi.emedha.in/api/v1/get-villa-leads?projectName=${vPrname}`);
      
      if (response.status === 200) {  // Check if the status is 200 OK
        setLeads(response.data);  // Store the response data in leads
     // Success alert
      } else {
        alert(`Unexpected response: ${response.statusText}`);  // Alert for non-200 status
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        // If there is a specific message in the error response, show it
        alert(err.response.data.message);  // Show the specific message from the server
      } else {
        // Generic error message if no specific message exists
        alert("An error occurred while fetching leads: " + (err.message || "Unknown error"));
      }
    } finally {
      setLoading(false);  // Set loading to false after the request is completed
    }
  };
  
  

  useEffect(()=>{
    fetchLeads()
  },[vPrname])


  const companyId=sessionStorage.getItem("companyId");
  
  return (
    <>
      {/* <div
        className="card mt-2 d-flex flex-row align-items-center"
        style={{
          border: "none",
          paddingLeft: 15,
          paddingRight: 15,
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div>
          <label style={{ fontSize: '13px', color: 'gray' }}>Search Filter</label>
          <br />
          <input
            value={filterInput}
            onChange={(e) => setFilterInput(e.target.value)}
            style={{
              height: "2.3rem",
              color: "gray",
              borderRadius: "0.3rem",
              outline: "none",
              width: "20rem",
              border: "0.7px solid lightgray",
            }}
            placeholder="Search Details.."
          />
        </div>
        <div>
          <div className="d-flex flex-row align-items-center p-2 mt-3" style={{width:'280px'}}>

          <Form.Group as={Col} md="12" controlId="validationCustom01" className="mr-2 p-2">
              <Typography style={{ color: 'gray', fontSize: 13 }}>ProjectName</Typography>
              <Form.Select
                required
                onChange={(e) => setVPrname(e.target.value)}
                value={vPrname}
                type="text"
                style={{ padding: '0.42rem', marginBottom: 14 }}
              >
                <option>Select Project</option>
                {filteredProjects.filter((item=>item.company_id===parseInt(companyId))).map((item) => (
                  <option key={item.ProjectName} value={item.ProjectName}>
                    {item.ProjectName}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">Please Enter Valid Project Name</Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="12" controlId="viewMode">
              <Typography style={{ color: "gray", fontSize: 13 }}>
                View Mode
              </Typography>
              <Form.Select
                onChange={(e) => setViewMode(e.target.value)}
                value={viewMode}
                style={{ padding: "0.42rem", marginBottom: 14 }}
              >
                <option value="Full View">Full View</option>
                <option value="Customized View">Customized View</option>
              </Form.Select>
            </Form.Group>
          </div>
        </div>
      </div> */}
      <Box sx={{ width: "100%" }}>
        
        {/* --- Centered Dashboard Header --- */}
        <Typography 
          sx={{ 
            color: "#1B2559", 
            fontSize: { xs: "24px", md: "28px" }, // Slightly smaller on mobile, larger on desktop
            fontWeight: "800", 
            textAlign: "center", // Centers the text perfectly
            letterSpacing: "-0.5px",
            mb: 3 // Margin bottom to give space before the filter box starts
          }}
        >
           Lead Report
        </Typography>

      <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // Stacks vertically on mobile, horizontally on tablet/desktop
    alignItems: { xs: "stretch", md: "flex-end" }, // Aligns the bottoms of the inputs on desktop
    gap: "16px",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E0E5F2",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)",
    width: "100%",
    boxSizing: "border-box",
    mb: 3, // Adds spacing below the filter bar
  }}
>
  {/* 1. Search Filter */}
  <Box > {/* flex: 1 allows it to take up the most space */}
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Search Filter
    </Typography>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "300px",
        height: "45px", // Standard premium input height
        backgroundColor: "#F4F7FE",
        borderRadius: "8px",
        padding: "0 16px",
        border: "1px solid transparent",
        transition: "all 0.2s ease",
        "&:focus-within": {
          border: "1px solid #4318ff", // Premium purple glow on focus
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 12px rgba(67, 24, 255, 0.05)",
        },
      }}
    >
      <FiSearch style={{ color: "#A3AED0", fontSize: "18px", marginRight: "12px" }} />
      <input
        value={filterInput}
        onChange={(e) => setFilterInput(e.target.value)}
        placeholder="Search Details..."
        style={{
          width: "100%",
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          fontSize: "14px",
          color: "#2B3674",
          fontWeight: "500",
        }}
      />
    </Box>
  </Box>

  {/* 2. Project Dropdown */}
  <Box sx={{ width: { xs: "100%", md: "250px" } }}> {/* Full width on mobile, 250px on desktop */}
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Project Name
    </Typography>
    <select
      required
      value={vPrname}
      onChange={(e) => setVPrname(e.target.value)}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="">Select Project</option>
      {filteredProjects
        .filter((item) => item.company_id === parseInt(companyId))
        .map((item) => (
          <option key={item.ProjectName} value={item.ProjectName}>
            {item.ProjectName}
          </option>
        ))}
    </select>
  </Box>

  {/* 3. View Mode Dropdown */}
  <Box sx={{ width: { xs: "100%", md: "200px" } }}> {/* Full width on mobile, 200px on desktop */}
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      View Mode
    </Typography>
    <select
      value={viewMode}
      onChange={(e) => setViewMode(e.target.value)}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="Full View">Full View</option>
      <option value="Customized View">Customized View</option>
    </select>
  </Box>
</Box>
</Box>

   <div style={{ display: "flex", alignItems: "center" }}>
  {viewMode === 'Customized View' && (
    <Dropdown>
      {/* Premium Toggle Button */}
      <Dropdown.Toggle 
        id="dropdown-custom-components"
        style={{
          backgroundColor: "#F4F7FE",
          color: "#4318ff",
          border: "1px solid #E0E5F2",
          borderRadius: "8px",
          height: "45px",
          padding: "0 20px",
          fontWeight: "700",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          boxShadow: "none",
          transition: "all 0.2s ease"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#E9EDF7"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#F4F7FE"}
      >
        Select Columns
      </Dropdown.Toggle>

      {/* Responsive Dropdown Menu */}
      <Dropdown.Menu 
        style={{ 
          width: "600px",       // Optimal width for desktop
          maxWidth: "90vw",     // CRITICAL: Prevents it from overflowing on a mobile screen
          maxHeight: "350px",   // Keeps it from breaking past the bottom of the screen
          overflowY: "auto",    // Enables vertical scrolling for long lists
          overflowX: "hidden",  // Prevents horizontal scrolling
          padding: "20px",
          borderRadius: "12px",
          border: "1px solid #E0E5F2",
          boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.15)",
          marginTop: "10px",
          zIndex: 9999,         // Ensures the menu pops up ON TOP of your data table
        }}
      >
        {/* Auto-flowing CSS Grid instead of rigid Rows/Cols */}
        <div 
          style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", 
            gap: "15px" 
          }}
        >
          {selectedColumns.map((col) => (
            <Form.Check
              key={col.id}
              type="checkbox"
              id={`checkbox-${col.id}`}
              label={col.label}
              checked={selectedColumnIds.includes(col.id)}
              onChange={() => handleColumnSelection(col.id)}
              title={col.label} // Shows the full name on hover if it gets truncated
              style={{
                color: "#2B3674",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                margin: 0,
                whiteSpace: "nowrap",    // Keeps the checkbox and text on the same line
                overflow: "hidden",      // Safely hides extra-long column names
                textOverflow: "ellipsis" // Adds "..." if text is too long for the mobile grid
              }}
            />
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )}
</div>
<TableContainer 
  sx={{ 
    marginTop: "20px", 
    borderRadius: "12px", 
    border: "1px solid #E0E5F2", 
    overflowX: "auto", // CRITICAL: Enables horizontal swiping on mobile
    backgroundColor: "#ffffff",
    boxShadow: "0px 4px 15px rgba(0,0,0,0.02)",
    // Custom slim scrollbar for a native app feel
    '&::-webkit-scrollbar': { height: '6px' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
  }}
>
  <Table sx={{ minWidth: 800 }} stickyHeader aria-label="premium dynamic table" id="table-to-xls">
    
    <TableHead>
 <TableRow>
  {selectedColumns
    .filter(col => col.isVisible)
    .map((col, index) => (
      <TableCell 
        key={index}
        align="start"
        sx={{ 
          minWidth: col.width || 120,
          background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)", // ✅ MOVE HERE
          color: "#ffffff",
          fontWeight: "700",
          fontSize: "13px",
          padding: "16px",
          borderBottom: "1px solid #E0E5F2",
          whiteSpace: "nowrap"
        }}
      >
        {col.label}
      </TableCell>
    ))}
</TableRow>
    </TableHead>

    <TableBody>
      {leads
        .filter(row => 
          selectedColumns.some(col => 
            col.isVisible && row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase())
          )
        )
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => (
          <TableRow hover key={index}>
            {selectedColumns
              .filter(col => col.isVisible)
              .map((col, idx) => (
                <TableCell 
                  key={idx} 
                  align="start" 
                  sx={{ 
                    fontSize: "13px", 
                    fontWeight: idx === 0 ? "700" : "500", // Makes the first column bold for readability
                    color: idx === 0 ? "#2B3674" : "#707eae", // Darker primary text, softer secondary text
                    minWidth: col.width,
                    padding: "14px 16px",
                    borderBottom: "1px solid #E0E5F2",
                    whiteSpace: "nowrap" // Keeps data looking clean and uniform
                  }}
                >
                  {row[col.id] || "—"} {/* Adds a sleek dash if the data is empty */}
                </TableCell>
              ))}
          </TableRow>
        ))}

        {/* Premium Empty State if filter returns nothing */}
        {leads.filter(row => 
          selectedColumns.some(col => 
            col.isVisible && row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase())
          )
        ).length === 0 && (
          <TableRow>
            <TableCell 
              colSpan={selectedColumns.filter(c => c.isVisible).length} 
              align="center" 
              sx={{ padding: "40px" }}
            >
              <Typography sx={{ color: "#A3AED0", fontWeight: "600", fontSize: "14px" }}>
                No leads found matching your filter.
              </Typography>
            </TableCell>
          </TableRow>
        )}
    </TableBody>

  </Table>
</TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={leads.filter(row => selectedColumns.some(col => col.isVisible && row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase()))).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <div className='d-flex flex-row align-items-center'>
      <ReactHTMLTableToExcel
  id="test-table-xls-button"
  className="download-table-xls-button green-button"
  table="table-to-xls"
  filename="lead_report"
  sheet="Lead Report"
  buttonText="Excel"
  style={{ marginLeft: '2rem' }} // You can still keep other inline styles
/>


        <Button
          variant="contained"
          color="danger"
          size="large"
          style={{ marginLeft: '2rem', height: '50px' }}
          onClick={downloadPDF}
        >
          PDF
        </Button>
      </div>
    </>
  );
};

export default LeadReport;

